import { merge } from 'lodash';

import { type AdditionalContentFieldType } from '@core/blocks/edu-flow-2/components/AdditionalContentFields/types';
import { type QuestionType } from '@core/blocks/edu-flow/components/Page/types';
import { type MonarchEditableAsset } from '@core/context/types';
import { type DeepPartial } from '@core/ts/types';

const personalizationQuestionPursuingHigherEducation = (
  question: QuestionType,
  {
    questionHeading,
    questionSubHeading,
    questionOptions,
    questionStepId,
    questionStepName,
    sidePanelContentType,
    sidePanelContentValue,
  }: MonarchEditableAsset
): QuestionType => {
  const questionFieldOptions = questionOptions?.map((option) => ({ value: option, ...option }));

  const populatedQuestion: DeepPartial<QuestionType> = {
    heading: questionHeading,
    postSubheading: questionSubHeading,
    stepId: questionStepId,
    stepName: questionStepName,
    conditionalContinue: [
      {
        action: 'CONTINUE',
        rules: [
          {
            field: 'reasonEducation',
            type: 'EXISTS',
          },
        ],
      },
    ],
    fields: [
      {
        name: 'reasonEducation',
        mode: 'radio',
        options: questionFieldOptions,
      },
    ],
    additionalContent: [
      {
        content: sidePanelContentValue,
        type: sidePanelContentType as AdditionalContentFieldType,
      },
    ],
  };

  return merge(populatedQuestion, question);
};

export default personalizationQuestionPursuingHigherEducation;
